define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		// Heading: heading used to render attribute
		heading: null,
		
		// Renderer: renderer for heading
		ren: null
	});
});